module.exports = __webpack_public_path__ + "img/icon-reload.a9406905.svg";